import { getLabel } from "../labels";

export let localizedScoreLabels = null;

export function getLocalizedScoreLabel(sportId, nativeScoreLabel) {
	if (!localizedScoreLabels) {
		localizedScoreLabels = {};
        const labels = getLabel('scores.localized_labels');
        if (labels.length > 0) {
            try {
                const localizedScoreLabelsTemp = JSON.parse(labels);
                for (let kk in localizedScoreLabelsTemp) {
                    localizedScoreLabels[(kk + "").toUpperCase().trim()] = localizedScoreLabelsTemp[kk];
                }	
            } catch(e) {
                console.log(e);
            }
        }
	}

	const keySearch = nativeScoreLabel.toUpperCase().trim();
	return localizedScoreLabels[sportId + "_" + keySearch] ||
		   localizedScoreLabels[keySearch] || 
		   nativeScoreLabel;
}
